import { inject, observer } from 'mobx-react';
import dynamic from 'next/dynamic';
import ComponentsErrorBoundary from '@/components/ErrorBoundary/ComponentsErrorBoundary';
import LazyloadOnFrame from '@/components/LazyloadOnFrame';
import styles from './Section.module.less';
import BaseSection from './BaseSection';
import cls from 'classnames';

const ProductOverviewMenus = dynamic(import('./Menus'), { ssr: false });
const PromotionalVideo = dynamic(import('./components/PromotionalVideo'), { ssr: false });
const ProductSectionMenusMobile = dynamic(import('@/pages/product/components/ProductOverview/Menus.mobile'), {
  ssr: false,
});

// 保留因为组件中没有引入，否则会出现样式错误
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

@inject('area', 'product', 'app', 'abtest')
@observer
class Index extends BaseSection {
  state = {
    overviewMenu: [],
    extraMenus: [],
    specsMenus: [],
  };

  componentDidMount() {
    const {
      productDetail: { id: pid },
      getProductDiff,
      fetchProductOverview,
      fetchProductRecommend,
      fetchAccessoryCompatibilities,
    } = this.props.product;

    const { isMobile } = this.props.app;
    const requests = [
      fetchProductRecommend(pid), // 推荐配件
      getProductDiff({ productId: pid }), // 处理包装清单数据
      fetchAccessoryCompatibilities(pid), // 配件适配性
      fetchProductOverview({ productId: pid, isMobile }),
    ];

    const PromiseAll = Promise.allSettled ? Promise.allSettled(requests) : Promise.all(requests);

    PromiseAll.then(() => {
      this.getMenus({
        cb: (overviewMenu) => {
          this.setState({ overviewMenu });
        },
      });
    });

    this.getMenus({
      cb: (overviewMenu) => {
        this.setState({ overviewMenu });
      },
    });

    this.getMenusExtra({
      cb: (extraMenus) => {
        this.setState({ extraMenus }, () => {
          this.getMenusSpecs({
            cb: (specsMenus) => {
              this.setState({ specsMenus });
            },
          });
        });
      },
    });
  }

  // props中传入cid & overviewType 因为浅比较无法透传内部数据的变化
  // eslint-disable-next-line
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.curSelectCommodityId !== this.props.product.curSelectCommodityId ||
      (prevProps.curSelectCommodityId === this.props.product.curSelectCommodityId,
      prevProps.overviewType !== this.props.product.overviewType)
    ) {
      this.getMenus({
        cb: (overviewMenu) => {
          this.setState({ overviewMenu });
        },
      });
    }
  }

  EnabledComponent = (key) => {
    const { overviewMenu, extraMenus, specsMenus } = this.state;
    const { isMobile } = this.props.app;
    const {
      productDetail: { videos = [] },
    } = this.props.product;
    switch (key) {
      case 'ProductSectionMenus':
        if (isMobile) {
          return (
            <ComponentsErrorBoundary name='ProductSectionMenusMobile'>
              <ProductSectionMenusMobile
                overviewMenu={overviewMenu}
                extraMenus={extraMenus}
                specsMenus={specsMenus}
                onChangeOverviewType={this.handleChangeOverviewType}
              />
            </ComponentsErrorBoundary>
          );
        } else {
          return (
            <ComponentsErrorBoundary name='ProductOverviewMenus'>
              <ProductOverviewMenus
                overviewMenu={overviewMenu}
                extraMenus={extraMenus}
                specsMenus={specsMenus}
                onChangeOverviewType={this.handleChangeOverviewType}
              />
            </ComponentsErrorBoundary>
          );
        }

      case 'PromotionalVideo':
        const overviewVideo = videos.find((o) => o.type === 'overview_video');
        if (!overviewVideo) return null;
        return <PromotionalVideo overviewVideo={overviewVideo} />;

      default:
        break;
    }
  };

  // H tag前面需要加上产品名的列表
  getHTag = (anchor = '', title) => {
    const { productDetail } = this.props.product;

    // 需要加上产品名
    const extraNames = ['a_overview', 'a_overview_specs', 'a_faqs', 'a_comments'];
    const list = ['a_overview', 'a_overview_specs', 'a_whatInTheBox', 'a_faqs', 'a_comments', 'a_recommendAccessory'];
    return (
      list.includes(anchor) && (
        <h2 className='hide' key={anchor}>
          {extraNames.includes(anchor) ? productDetail.name + ' ' : ''}
          {title}
        </h2>
      )
    );
  };

  render() {
    const { overviewMenu } = this.state;
    const { productDetail } = this.props.product;
    const {
      country: { X_Language, language },
    } = this.props.area;

    return (
      <div className={styles.secBottom} data-pid={productDetail.id}>
        {/* 详情页导航 */}
        <LazyloadOnFrame lazy>{this.EnabledComponent('ProductSectionMenus')}</LazyloadOnFrame>

        {/* 详情页导航 */}
        <LazyloadOnFrame lazy>{this.EnabledComponent('PromotionalVideo')}</LazyloadOnFrame>

        {/* 详情图各部分 */}
        {overviewMenu?.map((o, k) => {
          const { titleVisible = true, title, sectionTitle, Component, visible, anchor } = o;
          if (!Component || !visible) {
            // 标题添加Htag
            return this.getHTag(anchor, sectionTitle || title);
          }
          const isDesc = anchor === 'a_overview_desc';
          return (
            <div
              id={anchor}
              data-a={anchor}
              className={cls({
                [styles.section]: true,
              })}
              data-lang={language}
              key={o.anchor}
            >
              <ComponentsErrorBoundary name={`product Overview ${anchor}`}>
                <div className={styles.wrap} is_camera={`${productDetail.is_camera}`} data-isdesc={isDesc}>
                  {titleVisible && (
                    <div data-l={X_Language} className={styles.title}>
                      {sectionTitle || title}
                    </div>
                  )}
                  {/* 标题添加Htag */}
                  {this.getHTag(anchor, sectionTitle || title)}
                  <LazyloadOnFrame lazy={k > 2}>{Component}</LazyloadOnFrame>
                </div>
              </ComponentsErrorBoundary>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Index;
